import { LANGUAGE_CODES } from '../common/constants/languageCodes';

// SC-QA-36: the language the visitor came with (`lang` from the landing hand-off) holds for this visit, the tab's
// session, and is never saved on the account (decided by Valeriia, 2026-11-01). The menu's own choice still is.
const HANDOFF_KEY = 'checkvin.handoffLanguage';
// i18next-browser-languagedetector's cache: the browser-wide language the next visit starts from
const DETECTOR_CACHE_KEY = 'i18nextLng';

export const isSupportedLanguage = lang => Object.values(LANGUAGE_CODES).includes(lang);

export const rememberHandoffLanguage = lang => {
    if (!isSupportedLanguage(lang)) return;
    try {
        sessionStorage.setItem(HANDOFF_KEY, lang);
    } catch {
        // storage blocked: the language still applies on this page, just not after a reload
    }
};

export const getHandoffLanguage = () => {
    try {
        const lang = sessionStorage.getItem(HANDOFF_KEY);
        return isSupportedLanguage(lang) ? lang : null;
    } catch {
        return null;
    }
};

export const clearHandoffLanguage = () => {
    try {
        sessionStorage.removeItem(HANDOFF_KEY);
    } catch {
        // nothing stored
    }
};

const readCachedLanguage = () => {
    try {
        return localStorage.getItem(DETECTOR_CACHE_KEY);
    } catch {
        return null;
    }
};

const restoreCachedLanguage = cached => {
    try {
        if (cached) localStorage.setItem(DETECTOR_CACHE_KEY, cached);
        else localStorage.removeItem(DETECTOR_CACHE_KEY);
    } catch {
        // storage blocked: nothing was cached either
    }
};

// Shows the hand-off language now without making it the browser's saved language: i18next caches every change, and
// the signed-in app pushes a cached language that differs from the account's onto the account on its next load.
export const applyHandoffLanguage = (i18n, lang) => {
    if (!isSupportedLanguage(lang)) return Promise.resolve();
    const cached = readCachedLanguage();
    return Promise.resolve(i18n.changeLanguage(lang)).then(() => restoreCachedLanguage(cached));
};
